import { z } from 'zod';
import type { EntitlementRule } from '@/api/auth/missionImpactAuthAPI.schemas';

/**
 * Schema for creating a default entitlement. The rule itself is the generated polymorphic
 * EntitlementRule (built by the rule editor); we validate the surrounding form fields here.
 */
export const createDefaultEntitlementSchema = z.object({
  rule: z.custom<EntitlementRule>(),
  durationDays: z.number()
    .int()
    .positive('Duration must be a positive number')
    .nullish(),
});

/**
 * Schema for updating a default entitlement.
 */
export const updateDefaultEntitlementSchema = z.object({
  rule: z.custom<EntitlementRule>(),
  durationDays: z.number()
    .int()
    .positive('Duration must be a positive number')
    .nullish(),
});

export type CreateDefaultEntitlement = z.infer<typeof createDefaultEntitlementSchema>;
export type UpdateDefaultEntitlement = z.infer<typeof updateDefaultEntitlementSchema>;
